// src/middleware/UserTypeMiddleware.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserData } from '../utils/auth';
import { toast } from 'react-toastify';

const UserTypeMiddleware = ({ children, allowedTypes }) => {
  const navigate = useNavigate();
  const userData = getUserData();

  useEffect(() => {
    if (!userData || !allowedTypes.includes(userData.userType)) {
      toast.error('You are not authorized to access this page');
      navigate('/');
    }
  }, [navigate, userData, allowedTypes]);

  return userData && allowedTypes.includes(userData.userType) ? children : null;
};

export default UserTypeMiddleware;